module.exports = __webpack_public_path__ + "static/media/facebook.04e57b40.svg";